import { swayyColors, swayyFont } from "../../theme/tokens";

/** Shared listing-table metrics so Orders / Shipments headers stay one height. */
export const SWAYY_TABLE_HEAD_HEIGHT = 44;
export const SWAYY_TABLE_BODY_MIN_HEIGHT = 56;

export const swayyTableHeadCellSx = {
  fontSize: "0.7rem",
  fontWeight: 600,
  color: swayyColors.textSecondary,
  letterSpacing: "0.06em",
  textTransform: "uppercase" as const,
  whiteSpace: "nowrap" as const,
  height: SWAYY_TABLE_HEAD_HEIGHT,
  minHeight: SWAYY_TABLE_HEAD_HEIGHT,
  maxHeight: SWAYY_TABLE_HEAD_HEIGHT,
  py: 0,
  px: 2,
  lineHeight: 1.2,
  verticalAlign: "middle" as const,
  boxSizing: "border-box" as const,
  borderBottom: `1px solid ${swayyColors.border}`,
  backgroundColor: swayyColors.pageBg,
  fontFamily: swayyFont,
  textAlign: "center" as const,
};

export const swayyTableHeadCellLeftSx = {
  ...swayyTableHeadCellSx,
  textAlign: "left" as const,
};

export const swayyTableHeadRowSx = {
  height: SWAYY_TABLE_HEAD_HEIGHT,
  "& > .MuiTableCell-head": {
    height: SWAYY_TABLE_HEAD_HEIGHT,
    minHeight: SWAYY_TABLE_HEAD_HEIGHT,
    maxHeight: SWAYY_TABLE_HEAD_HEIGHT,
  },
};

export const swayyTableSortLabelSx = {
  color: "inherit",
  fontFamily: swayyFont,
  fontSize: "inherit",
  fontWeight: "inherit",
  letterSpacing: "inherit",
  lineHeight: 1.2,
  textTransform: "inherit" as const,
  display: "inline-flex",
  alignItems: "center",
  maxHeight: SWAYY_TABLE_HEAD_HEIGHT,
  "& .MuiTableSortLabel-icon": {
    fontSize: 14,
    width: 14,
    height: 14,
    ml: 0.5,
    opacity: 0.35,
    color: `${swayyColors.pine} !important`,
  },
  "&.Mui-active": {
    color: swayyColors.deepGreen,
    "& .MuiTableSortLabel-icon": {
      opacity: 1,
      color: `${swayyColors.pine} !important`,
    },
  },
  "&:hover": {
    color: swayyColors.pine,
  },
};

export const swayyTableBodyCellSx = {
  fontSize: "0.82rem",
  fontWeight: 400,
  color: swayyColors.textPrimary,
  minHeight: SWAYY_TABLE_BODY_MIN_HEIGHT,
  py: 1.25,
  px: 2,
  verticalAlign: "middle" as const,
  boxSizing: "border-box" as const,
  borderBottom: `1px solid ${swayyColors.border}`,
  fontFamily: swayyFont,
  textAlign: "center" as const,
};

export const swayyTableBodyCellLeftSx = {
  ...swayyTableBodyCellSx,
  textAlign: "left" as const,
};
